import StudentGoalReflectionCard from './StudentGoalReflectionCard';

const GOAL_TYPES = ['hours', 'confidence', 'challenge', 'help'];

const StudentGoalReflectionContainer = ({ courseId, studentId }) => {
  // This file will eventually have logic for choosing which goal to render
  // But for now will try to render all the goal cards (if enabled)
  return (
    <>
      {GOAL_TYPES.map((goal) => (
        <StudentGoalReflectionCard
          key={goal}
          courseId={courseId}
          studentId={studentId}
          goal={goal}
        />
      ))}
    </>
  );
};

export default StudentGoalReflectionContainer;
